import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Upload } from 'lucide-react';
import { useUploadStore } from '../stores/uploadStore';
import { useAuthStore } from '../stores/authStore';

/* [PATCH sop-napredek-fe v1] Indikator uvoza (levo od zvonca).
   Pokriva OBE poti:
     - posamicni / povleci-spusti -> uploadStore.poPodjetju     (tece v brskalniku)
     - sop, gumb "Uvoz"           -> uploadStore.sopPoPodjetju  (tece na strezniku)
   Sop tece na strezniku, zato ga po osvezitvi strani prevzamemo nazaj prek
   obnoviSop. Ucinek MORA stati pred zgodnjim returnom (pravilo hookov).
   Zvonec ostaja loceni kanal "novi dokumenti" — sem se ne dotika. */
export function UvozIndikator() {
  const navigate = useNavigate();
  const selectedId = useAuthStore((s: any) => s.selectedCompany?.id || null);
  const selectedNaziv = useAuthStore((s: any) => s.selectedCompany?.name || '');
  const stanje = useUploadStore((s: any) => (selectedId ? s.poPodjetju[selectedId] : undefined));
  const sop = useUploadStore((s: any) => (selectedId ? s.sopPoPodjetju[selectedId] : undefined));
  const obnoviSop = useUploadStore((s: any) => s.obnoviSop);

  useEffect(() => {
    if (!selectedId) return;
    obnoviSop(selectedId, selectedNaziv);
  }, [selectedId]);  /* [PATCH sop-napredek-fe v1a] namenoma samo selectedId: obnoviSop je stabilna referenca iz store-a, naziv je le za prikaz */

  const sopAktiven = !!(sop && sop.aktiven);
  const d: any = (sop && sop.podatki) || {};
  const sopSkupaj = d.st_dokumentov || 0;
  const sopObdelano = (d.st_koncano || 0) + (d.st_preskoceno || 0) + (d.st_napak || 0);
  const sopPct = sopSkupaj > 0 ? Math.round((sopObdelano / sopSkupaj) * 100) : 0;
  const posAktiven = !!(stanje && stanje.aktiven);
  const posPct = posAktiven && stanje.skupaj > 0 ? Math.round((stanje.koncano / stanje.skupaj) * 100) : 0;

  if (!posAktiven && !sopAktiven) return null;

  return (
    <>
      {sopAktiven && (
        <button
          type="button"
          onClick={() => navigate(`/dokumenti?tip=${sop.docType || 'prejeti_racun'}&sop=${sop.batchId}&ts=${Date.now()}`)}
          className="flex items-center gap-2 px-3 py-1 rounded-lg bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 hover:border-blue-400 transition"
          title={sop.companyNaziv ? `Uvoz: ${sop.companyNaziv} — klik odpre okno` : 'Uvoz — klik odpre okno'}
        >
          <Upload className="w-4 h-4 text-blue-500 animate-pulse" />
          <div className="flex flex-col">
            <span className="text-xs font-medium text-blue-700 dark:text-blue-300 leading-none mb-0.5">Uvažam {sopObdelano}/{sopSkupaj}</span>
            <div className="w-24 h-1 bg-blue-200 dark:bg-blue-800 rounded-full overflow-hidden">
              <div className="h-full bg-blue-500 transition-all" style={{ width: `${sopPct}%` }} />
            </div>
          </div>
        </button>
      )}
      {posAktiven && stanje && (
        <div
          className="flex items-center gap-2 px-3 py-1 rounded-lg bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800"
          title={stanje.companyNaziv ? `Uvoz: ${stanje.companyNaziv}` : 'Uvoz'}
        >
          <Loader2 className="w-4 h-4 text-blue-500 animate-spin" />
          <div className="flex flex-col">
            <span className="text-xs font-medium text-blue-700 dark:text-blue-300 leading-none mb-0.5">Uvažam {stanje.koncano}/{stanje.skupaj}</span>
            <div className="w-24 h-1 bg-blue-200 dark:bg-blue-800 rounded-full overflow-hidden">
              <div className="h-full bg-blue-500 transition-all" style={{ width: `${posPct}%` }} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
